import { render, staticRenderFns } from "./NoChainScrollContainer.vue?vue&type=template&id=625c83cc&scoped=true"
import script from "./NoChainScrollContainer.vue?vue&type=script&lang=js"
export * from "./NoChainScrollContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c83cc",
  null
  
)

export default component.exports